<!-- 
Card for displaying a single levy collection task.
-->
<template>
  <div>
    <v-hover class="mt-2 mb-3">
      <v-card 
        slot-scope="{ hover }"
        :v-ripple="canRunTask(task.claimType)"
        :style="(canRunTask(task.claimType) ? 'cursor:pointer;' : 'cursor:default;')"
        :class="canRunTask(task.claimType) ? '' : 'grey--text text--darken-1'"
        flat
        @click.stop="run"
        @keydown.enter="run"
      >
        <div v-if="hover && canRunTask(task.claimType)" class="d-flex reveal"/>
        <v-card-text class="pb-0">
          <h3 :class="muted ? 'subheading mb-3' : 'title mb-3'">
            <v-icon v-if="!muted" :color="hover && canRunTask(task.claimType) ? 'primary' : ''" class="mr-2">{{ getIcon(task.type) }}</v-icon>
            {{ lookups.levyCollectionTaskTypeDescriptions[task.type] }}
            <v-tooltip v-if="!canRunTask(task.claimType)" bottom>
              <v-icon slot="activator" color="red darken-4" class="subheading lock">lock</v-icon>
              <span>You do not have permission to run this task</span>
            </v-tooltip>
          </h3>
          <p>
            {{ task.description }}
          </p>
          <v-alert 
            v-if="task.warning"
            :dismissible="false" color="primary" 
            type="info" icon="event_note" class="mb-3 d-inline-flex" outline
          >
            <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
            <p class="caption ma-0 grey--text text--darken-4" v-html="highlightWarning(task.warning)"/>
          </v-alert>
        </v-card-text>
        <v-card-actions v-if="canRunTask(task.claimType)" class="pt-0">
          <v-spacer/>
          <v-btn flat color="primary">{{ lookups.levyCollectionTaskTypeDescriptions[task.type] }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import taskMixins from "@/mixins/task.mixins";

export default {
  mixins: [lookupMixins, taskMixins],
  props: {
    task: {
      required: true,
      type: Object
    },
    muted: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    run() {
      if (this.canRunTask(this.task.claimType)) {
        this.$emit("run", this.task);
      }
    },
    highlightWarning(text) {
      var warningPos = text.indexOf("WARNING -");
      if (warningPos < 0) {
        return text;
      }
      var baseText = text.substr(0, warningPos);
      var warning = text.substr(warningPos);
      return baseText + "<span class='error--text'>" + warning + "</span>";
    }
  }
};
</script>
